/* 统一请求入口 */
import Vue from 'vue';
import { Message } from 'element-ui';
import apiPath from './apiPath.js';

const errorHandler = (resp, failFn, errorMsg, cancelMsg) => {
    let errcode = resp.body.code || resp.body.errcode;
    let errmsg = resp.body.msg || resp.body.errmsg;

    if (typeof failFn === 'function') {
        failFn(resp.body);
    }
    if (typeof errcode !== 'undefined' && typeof errmsg !== 'undefined') {
        if (errcode === 5000 || errcode === 5001) {
            alert(`登录态失效[${errcode}]，请前往灵盾登录。`);
            location.href = apiPath.UNIFY_BACKENDS;
            return;
        }
        !cancelMsg && Message({
            type: 'error',
            message: `${errmsg}(${errcode})`,
            duration: 1500
        });
    } else {
        !cancelMsg && Message({
            type: 'error',
            message: errorMsg,
            duration: 1500
        });
    }
}

export const requestApi = ({
    method = 'get',
    url,
    body,
    options = {},
    successFn,
    failFn,
    errorMsg = '抱歉，网络错误',
    cancelMsg = false
}) => {
    let query1 = {};
    let query2 = {};
    options = Object.assign({
        timeout: 10000
    }, options);

    if (['post', 'put', 'patch'].indexOf(method) !== -1) {
        query1 = typeof body.append !== 'function' ? JSON.stringify(body) : body;
        query2 = options;
    } else {
        query1 = options;
    }

    return Vue.http[method](url, query1, query2).then((resp) => {
        if (typeof resp.body !== 'object') {
            throw `服务端返回非json数据:${resp.body}`;
        }
        let errcode = resp.body.code;
        let errmsg = resp.body.msg;
        if (errcode == 1) {
            if (typeof successFn === 'function') {
                successFn(resp.body.data);
            }
        } else {
            errorHandler(resp, failFn, errorMsg, cancelMsg);
        }
    }, resp => {
        errorHandler(resp, failFn, errorMsg, cancelMsg);
    }).catch((err) => {
        Message({
            type: 'warning',
            message: '抱歉，请求处理异常',
            duration: 1500
        });
        let errMsg = `request捕获到错误:${err.toString()}`;
        console.log(errMsg);
    });
};

const scriptCache = {};
export const loadScript = (url) => {
    return new Promise(function(resolve, reject) {
        if (scriptCache[url]) {
            resolve();
            return;
        }
        const script = document.createElement("script")
        script.type = "text/javascript";
        if (script.readyState){ //IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                    script.onreadystatechange = null;
                    scriptCache[url] = true;
                    resolve();
                }
            };
        } else { //Others: Firefox, Safari, Chrome, and Opera
            script.onload = function(){
                scriptCache[url] = true;
                resolve();
            };
        }
        script.src = url;
        document.body.appendChild(script);
    });
}



// WEBPACK FOOTER //
// ./src/service/requestApi.js